import { FormFieldData } from "modules/forms";
import { OpportunityEntity } from "shared/types/domain/OpportunityEntity";
import { IMapper } from "shared/types/IMapper";
import { OpportunityByIdResponse } from "../queries/view-opportunity.queries.types";

export class OpportunityEntityMapper implements IMapper<OpportunityByIdResponse, FormFieldData<OpportunityEntity>> {
    map(entity: OpportunityByIdResponse): FormFieldData<OpportunityEntity> {
        return {
            depotPcId: entity.opportunity.depotPcId,
            whatHappened: entity.opportunity.whatHappened,
            whoShouldBeCommended: entity.opportunity.whoShouldBeCommended,
            anonymousEntry: entity.opportunity.anonymousEntry,
            reporterType: entity.opportunity.reporterType,
            reporterContactName: entity.opportunity.reportedBy?.reporterContactName,
            reporterPhoneNumber: entity.opportunity.reportedBy?.reporterPhoneNumber,
            reporterEmail: entity.opportunity.reportedBy?.reporterEmail,
            incidentDate: entity.opportunity.incidentDate,
            processId: entity.opportunity.processId,
            reachId: entity.opportunity.reachId,
            nearMissId: entity.opportunity.observationId
        }
    }
}